import { RouteRecordRaw } from "vue-router";
import { auth } from "../middlewares/auth";
import { useOrdersStore } from "@/stores/orders";
import { useCartStore } from "@/stores/cart";
import { useCheckoutStore } from "@/stores/checkout";

const routes: RouteRecordRaw[] = [
  {
    path: "/:company?/ticket/payments",
    name: "Payments",
    component: () => import("@/views/Ticket/PaymentListing.vue"),
    meta: {
      middlewares: [ auth ],
    },
  },
  {
    path: "/:company?/ticket/list/:id",
    name: "TicketList",
    component: () => import("@/views/Ticket/PaymentDetails.vue"),
    meta: {
      middlewares: [ auth ],
    },
    beforeEnter(to, from, next) {
      useCartStore().reset();
      useCheckoutStore().reset();

      if (useOrdersStore().selected === null) {
        return next({ name: "Payments" });
      }

      next();
    },
  },
  {
    path: "/:company?/user/data",
    name: "UserProfile",
    component: () => import("@/views/user/profile/user-profile.vue"),
    meta: {
      middlewares: [ auth ],
    },
  },
];

export default routes;
